import { Constants } from '@src/app/commons/Constants';
import { DEBUG } from '@src/DEBUG';
import { XsBaseClass } from '../controllers/base.class';
DEBUG.open ( '/xs/controllers/propsicle' );

const Hash = require('object-hash');

/*
  Propsicle handles collections of properties, with caching and change detection (so you don't have to)
*/

export class XsPropsicle extends XsBaseClass {

  debugId:string = 'PROPSICLE';

  schemas:any = {

    _sniffTypes: [
      { class: 'Entity', sniffing: ['_model','_show','_propertyNames'], type:'cesium.entity', subTypeSniffing: [ '_polygon','_polyline','_point','_billboard','_corridor','_ellipse','_rectangle','_wall' ] },
      { class: 'Cesium3DTileset', type:'cesium.tileset', config:{ itemPropertiesToken:'_properties', useAPI:true } },
      { class: 'Cesium3DTileset', sniffing: ['isCesium3DTileset','_pointCloudEyeDomeLighting'], type:'cesium.pointcloud', config:{ itemPropertiesToken:'_properties' } },
      { class: 'Transform', sniffing: ['transformType'], type:'fdm.transform' }
    ],

    fdm: {
      transform: {},
      annotation: {},
    },

    cesium: {
      entity: {
        show: 'show',
        positions: '$.positions',
        position: 'position',
        color: '$.material.color',
        icon: '$.image',
        _polygon: {
          positions: '$.hierarchy',
          test: '$.material.something'
        },
      }
    }
  };

  // cached and compiled schemas
  schemasCompiled:any = {};

  itemData:any = {};

  // cumulative stats
  metaData:any = {
    types: {},
    subtypes: {},
    properties: {},
    attributes: {}
  };


  first:any = null;

  constructor ( config:any = {} ) {

    // config setup, with defaults
    super(config, {

      // incoming items
      items: [], 

      // detect the type of item so we can use proper schemas for complex objects
      itemTypeDetection: true,
  
      // does each item have a property object? null means no, just pull the properties from the item directly, otherwise
      // use the token, for example; item[property] (for example, Cesium entities use item._properties)
      itemPropertiesToken: null, 
      
      // does each property have an object or sub-property to pull data from? null means no, the property itself
      // is the value. If value given, the property is an object and we'll use this token, for example; item[property]['_value']
      // (for example, Cesium's properties are all ConstantValue classes with a ._value property)
      itemPropertiesSubToken: null,

      // some properties are stored and accessed through APIs (ie. Cesium PropertyStore), so we can use those
      // APIs instead of direct access, if we have detected the right types. Default is direct access.
      useAPI:false

  });

    // console.log( this.debugId + ' :: CONSTRUCTOR');
    DEBUG.log ( '/xs/controllers/propsicle' );

    // console.log ( 'construct', config, this._config );

    // start checking
    this.updateItems();
  }

  zz:number = 0;

  updateItems ( items:any = null ) {

    if ( items && items.length ) {
      this._config.items = items;
    }

    this.zz = 0;

    // console.log ( 'updateItems', this._config );

    if ( this._config.items && this._config.items.length ) {
      this._config.items.forEach ( item => {
        if ( !this.first ) {
          this.first = item;
        }
        // if ( this.zz == 0 ) { console.log ( 'updateItems item', item ); }
        if ( item ) {
          if ( this._config.itemTypeDetection ) {
            this.itemTypeDetection(item);
            // if ( this.zz == 0 ) { console.log ( 'updateItems type', item ); }
          }
          // if ( this.zz == 0 ) { console.log ( 'updateItems pop', item ); }
          this.updateProperties(item);
        } else {
          console.log('@err',item);
        }
        this.zz++;
      });
    }
  }

  getItemId ( item:any ) {
    if ( !item['__uuid'] ) {
      item['__uuid'] = this.__uuidv4();
    }
    if ( !this.itemData[item['__uuid']] ) {
      this.itemData[item['__uuid']] = { 
        meta: { uuid:item['__uuid'], type:null, subtype:null },
        properties:{ __has_live_data:false, __hash:null, __hash$:null },
        attributes:{ __has_live_data:false, __hash:null, __hash$:null },
        rules:{ __has_live_data:false, __hash:null, __hash$:null }, 
        __hash:null, __hash$:null
      };
    }
    return item['__uuid'];
  }

  itemTypeDetection ( incomingItem:any ) {

    const itemId = this.getItemId(incomingItem);
    const item = this.itemData[itemId];

        
    let foundType = null;
    let foundSubType = null;
    
    // console.log ( 'typeDetection', [ itemId, item, incomingItem['__type'] ] );

    // got no type?
    // if ( !incomingItem['__type'] ) {

      const construct = incomingItem.constructor ? incomingItem.constructor : null;
      const classTest = construct ? construct.name : 'null';

      

      // let's sniff our class
      const findClass = this.schemas._sniffTypes.filter ( c => c.class == classTest );

      let foundClass = null;

      // console.log ( 'typeDetection', [ itemId, incomingItem ], [ classTest, findClass ] );
    
      if ( findClass ) {

        findClass.forEach ( rule => {

          if ( rule.sniffing ) {
            let foundSniffs = 0;
            rule.sniffing.forEach ( key => {
              if ( incomingItem.hasOwnProperty(key) ) {
                foundSniffs++;
              }
            });
            if ( rule.sniffing.length == foundSniffs ) {
              foundType = rule.type;
              foundClass = rule;
            }
          } else {
            foundType = rule.type;
              foundClass = rule;
          }

          if ( rule.subTypeSniffing ) {
            rule.subTypeSniffing.forEach ( key => {
              if ( incomingItem.hasOwnProperty(key) && incomingItem[key] ) {
                foundSubType = key;
              }
            });
          }
          
        });
      }

      if ( foundClass && foundClass.config ) {
        this.__config(foundClass.config);
      }

      if ( foundType ) {
        incomingItem['__type'] = item.meta.type = foundType;
        if ( !this.metaData.types[foundType] ) {
          this.metaData.types[foundType] = 0;
        }
        this.metaData.types[foundType]++;
      }
      if ( foundSubType ) {
        incomingItem['__sub_type'] = item.meta.subtype = foundSubType;
        if ( !this.metaData.subtypes[foundSubType] ) {
          this.metaData.subtypes[foundSubType] = 0;
        }
        this.metaData.subtypes[foundSubType]++;
      }

      if ( this.first && this.first['__uuid'] == incomingItem['__uuid'] ) {
        // console.log('typetest', itemId, classTest, foundClass, foundType, foundSubType );
      }

      this.compileSchemaFor(incomingItem,foundClass);
      
    // }

    // if ( this.zz == 0 ) { console.log ( 'typeDetection', incomingItem, foundType, foundSubType ); }

  }

  compileSchemaFor ( incomingItem:any, findClass:any = {}, forceCompile:boolean = false ) {

    const itemId = this.getItemId(incomingItem);
    let schema = null;

    if ( !this.schemasCompiled[incomingItem['__type']] || forceCompile ) {

      this.schemasCompiled[incomingItem['__type']] = {};

      schema = this.schemasCompiled[incomingItem['__type']];

      const schemaTemplate = this.__reach( this.schemas, incomingItem['__type'] );
      const typeToken = incomingItem['__sub_type'] ? incomingItem['__sub_type'] : '#';
      
      // console.log('@schemaTemplate',incomingItem['__type'], schemaTemplate, typeToken );
      
      if ( schemaTemplate ) {

        // first pass; only normal properties (without '_' as first character)
        Object.keys( schemaTemplate ).forEach ( prop => {
          if ( prop.substr(0,1) !== '_' ) {
            schema[prop] = schemaTemplate[prop];
          }
        });

        // second pass; only typed properties
        Object.keys( schemaTemplate ).forEach ( prop => {
          if ( prop.substr(0,1) == '_' && incomingItem['__sub_type'] == prop ) {
              Object.keys( schemaTemplate[prop] ).forEach ( p => {
                schema[p] = schemaTemplate[prop][p];
              });
          }
        });
      }

      if ( schema ) {
        Object.keys( schema ).forEach ( p => {
          schema[p] = (''+schema[p]).trim().replace('$',typeToken);
        });
        this.schemasCompiled[incomingItem['__type']] = schema;
      }

      // console.log('@schema done', this._config, schema );

    }
    
    // if ( this.zz == 0 ) { console.log ( 'schema', incomingItem, schema ); }
  }

  updateItemHash ( incomingItem:any ) {
    const itemId = this.getItemId(incomingItem);
    const item = this.itemData[itemId];
    item['__hash'] = Hash ( item['properties']['__hash'] + item['attributes']['__hash'] );
  }

  changeDetectAttributes ( incomingItem:any ) {
    let dirty:string[] = null;
    const itemId = this.getItemId(incomingItem);
    const item = this.itemData[itemId];
    Object.keys(item.attributes).forEach ( key => {
      if ( item.attributes[key] ) {
        if ( item.attributes[key].latest !== item.attributes[key].current ) {
          if ( !dirty ) {
            dirty = [];
          }
          dirty.push(key);
        }
      }
    });
    return dirty;
  }

  solidifyDirtyAttributes ( incomingItem:any, dataNames:any = [] ) {
    const itemId = this.getItemId(incomingItem);
    const item = this.itemData[itemId];
    let data = {};
    dataNames.forEach ( key => {
      data[key] = item.attributes[key].latest;
    });
    this.updateItemData ( itemId, 'attributes', item, data, 'current' );
  }

  updateItemData ( itemId:string, type:string = 'properties', item:any, data:any = {}, field:string = 'latest' ) {

    let hash = null;
    let live = false;

    if ( !item ) {
      return;
    }

    Object.keys(data).forEach ( key => {
      if ( !hash ) {
        hash = '';
      } else {
        hash = hash + '&';
      }
      if ( key.indexOf('$') === 0 ) {
        live = true;
      }
      if ( !item[type][key] ) {
        item[type][key] = { latest:null, current:null, type:null, min:null, max:null, map:null, unique:1 };
      }
      item[type][key][field] = data[key];

      hash = hash + key +'-'+ data[key];
      if ( !this.metaData[type][key] ) {
        this.metaData[type][key] = {};
      }
      this.metaData[type][key][itemId] = key;
    });
    item[type]['__hash'] = Hash(hash);
    item[type]['__has_live_data'] = live;
  }

  updateAttributes ( incomingItem:any, properties:any ) {
    const itemId = this.getItemId(incomingItem);
    const item = this.itemData[itemId];
    this.updateItemData ( itemId, 'attributes', item, properties );
  }

  updateAllLiveProperties ( incomingItems:any[] = [] ) {
    incomingItems.forEach ( item => {
      this.updateLiveProperties(item);
    });
  }

  updateLiveProperties ( incomingItem:any ) {
    const props = this.getLiveProperties(incomingItem);
    if ( props ) {
      const itemId = this.getItemId(incomingItem);
      const item = this.itemData[itemId];
      this.updateItemData ( itemId, 'properties', item, props );
    }
  }

  getLiveProperties(incomingItem:any) {
    let properties:any = null;
    if ( incomingItem['__live_data'] ) {
      properties = {};
      Object.keys(incomingItem['__live_data']).forEach ( key => {
          properties['$'+key] = '$'+key;
      });
    }
    return properties;
  }

  updateProperties ( incomingItem:any ) {

    const itemId = this.getItemId(incomingItem);
    const item = this.itemData[itemId];

    // console.log('@propPopulate', this._config, incomingItem, itemId, item );

    let properties = null;
    let final = {};
    let rules = {};

    if ( this._config.itemPropertiesToken ) {
      properties = incomingItem[this._config.itemPropertiesToken];
    } else {
      properties = incomingItem;
    }

    if ( this._config.useAPI ) {

      // if ( this._)
    }
    
    if ( properties ) {
      Object.keys(properties).forEach ( key => {
        let property = null;
        if ( this._config.itemPropertiesSubToken ) {
          property = properties[key][this._config.itemPropertiesSubToken];
        } else {
          property = properties[key];
        }

        // simple type detection; we don't really support arrays or objects as values
        let t = typeof property;

        rules[key] = { type:'string', max: null, min:null, map:null, unique:1 };

        // currently, by objects we mainly mean Cesium property buckets, with min and max values for numbers (mainly for pointclouds)
        if ( property && typeof property == 'object' ) {
          final[key] = null;
          // console.log ( 'populate p', key, item, property );
          if ( property['maximum'] ) {
            rules[key].max = property['maximum'];
            rules[key].type = 'number';
          }
          if ( property['minimum'] ) {
            rules[key].min = property['minimum'];
            rules[key].type = 'number';
          }
        } else {
          if ( item && property ) {
            final[key] = property;
            rules[key].type = this.sniffType(property);
          }
        }

      });

      // update the item
      this.updateItemData ( itemId, 'properties', item, final );

      // and update any rules, if we found them
      Object.keys(rules).forEach ( key => {
        if ( item && item.properties[key] ) {
          item.properties[key].type = rules[key].type;
          item.properties[key].min = rules[key].min;
          item.properties[key].max = rules[key].max;
          item.properties[key].map = rules[key].map;
          item.properties[key].unique = rules[key].unique;
        }
      });
    }

    // console.log ( 'populate', incomingItem, itemId, final, rules, item );

    // console.log('@propPopulate DONE', item );

  }

  getPropertyNames ( incomingItem:any ) {

    const itemId = this.getItemId(incomingItem);
    const item = this.itemData[itemId];

    // console.log('##PROP_NAMES', incomingItem, itemId, item );

    if ( !item || !item.properties ) {
      // console.log('##PROP_NAMES ERROR', itemId, item );
      return [];
    }

    const keys = Object.keys(item.properties);
    // console.log('##PROP_NAMES KEYS', keys );

    if ( keys && keys.length ) {
      return keys.filter( k => k.indexOf('__') !== 0 );
    }

    return [];
  }

  getPropertyNamesObj ( incomingItem:any, propStore:any = null ) {

    const itemId = this.getItemId(incomingItem);
    const item = this.itemData[itemId];

    // console.log('##PROP_NAMES_OBJ', incomingItem, itemId, item );

    if ( !item || !item.properties ) {
      // console.log('##PROP_NAMES_OBJ ERROR', itemId, item );
      return [];
    }

    const keys = Object.keys(item.properties);

    // console.log('##PROP_NAMES_OBJ KEYS', keys );

    let ret = [];
    if ( keys && keys.length ) {
      let these = keys.filter( k => k.indexOf('__') !== 0 );
      if ( these ) {
        these.forEach ( key => {
          let i = item.properties[key];
          let j = propStore ? propStore.properties[key] : null;
          let u = i.unique;
          let t = i.type+'_unique';
          // console.log('!', key, t, j );
          if ( j && j['___lengths'] && j['___lengths'][i.type+'_unique'] ) {
            u = j['___lengths'][i.type+'_unique'];
          }
          ret.push({ value:key, type:i.type, unique:u });
        })
      }
    }

    // console.log('###PROP_OBJS', propStore, ret );

    return ret;
  }

  getPropertyValues ( incomingItem:any, propStore:any = null, key:string = null ) {

    const itemId = this.getItemId(incomingItem);
    const item = this.itemData[itemId];

    if ( !item || !key || !propStore ) {
      return null;
    }

    let i = item.properties[key];
    let j = propStore ? propStore.properties[key] : null;

    if ( j && j['___unique'] ) {
      return j['___unique'];
    }

    return null;

  }

  sniffType ( property:any ) {
    return typeof property;
  }
  

}
